import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import DashboardHeader from '../../components/dasboardHeader/index.vue'
import SideNav from '../../components/sideNavBar/index.vue'
import { showErrorToast, showSuccessToast } from '../../services/UI'
import UserService from '../../services/UserService'

export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  data () {
    return {
      url: '',
      photoFile: {}
    }
  },
  components: {
    DashboardHeader,
    SideNav
  },
  mounted () {
    // window.analytics.page('profile')
    window.analytics.identify('profile', {
      path: '/profile'
    })
  },
  methods: {
    handleLogoFileChange (e) {
      this.photoFile = this.$refs.fileLogo.files[0]
      const file = e.target.files[0]
      if (file.size > 2097152) {
        showErrorToast(this, 'Upload document with size less that 2MB')
        return
      }
      this.url = URL.createObjectURL(file)
      showSuccessToast(this, 'Document Uploaded Succesfully')
    },
    async uploadFile (file) {
      const signedUrl = await UserService.preSignedUrl(
        file.name
      )
      if (signedUrl) {
        await fetch(signedUrl.secureUrl, {
          method: 'PUT',
          body: file,
          processData: false,
          contentType: false,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      }
      return signedUrl
    },
    async updateCompanyLogo () {
      this.loading = true
      const user = await UserService.getUser()
      const companyId = user.organizations[0].organization.companies[0].id
      if (!this.photoFile.name) {
        showErrorToast(this, 'Please select Logo image')
        return
      }
      const photoUploadResponse = await this.uploadFile(this.photoFile)

      const res = await UserService.updateCompany(
        photoUploadResponse && { ...photoUploadResponse }, companyId
      )
      this.loading = false
      if (res) {
        showSuccessToast(this, 'Updated the company.')
      } else {
        showErrorToast(this, 'Couldnt update the company.')
      }
    }
  }
}
